export default __webpack_public_path__ + "static/media/lines.bd244538.svg";